import * as React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { Typography, useMediaQuery } from '@mui/material';
import { getBreakPoints } from '../../components/other/ConfigBasic';
import { useTranslation } from 'react-i18next';

export default function Legal() {
    const desktop900 = useMediaQuery(getBreakPoints().desktop900);
    const { t } = useTranslation();

    const getMaxHeight = () => {
        if (desktop900) {
            return 'calc(100vh - 96px)';
        } else {
            return 'calc(100vh - 152px)';
        }
    };

    return (
        <Grid container xs={12} xsOffset={0} md={6} mdOffset={3} xl={4} xlOffset={4} sx={{ overflowY: 'auto', maxHeight: getMaxHeight() }}>
            <Grid xs={12}>
                <Typography sx={{ fontFamily: 'CircularProMedium', fontSize: '20px !important', color: '#212121' }}>{t('legalNotes')}</Typography>
            </Grid>
            <Grid xs={12}>
                <Typography sx={{ fontFamily: 'CircularProMedium', fontSize: '14px !important', color: '#212121' }}>Material UI (MUI)</Typography>
                <Typography sx={{ fontSize: '14px !important', color: '#757575' }}>
                    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the “Software”), to deal in
                    the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
                    the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
                    <br />
                    <br />
                    The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
                    <br />
                    <br />
                    THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR
                    A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
                    ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                </Typography>
            </Grid>
            <Grid xs={12}>
                <Typography sx={{ fontFamily: 'CircularProMedium', fontSize: '14px !important', color: '#212121' }}>i18</Typography>
                <Typography sx={{ fontSize: '14px !important', color: '#757575' }}>
                    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the “Software”), to deal in
                    the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
                    the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
                    <br />
                    <br />
                    The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
                    <br />
                    <br />
                    THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR
                    A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
                    ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                </Typography>
            </Grid>
            <Grid xs={12}>
                <Typography sx={{ fontFamily: 'CircularProMedium', fontSize: '14px !important', color: '#212121' }}>Apollo</Typography>
                <Typography sx={{ fontSize: '14px !important', color: '#757575' }}>
                    Copyright (c) 2022 Apollo Graph, Inc. (Formerly Meteor Development Group, Inc.)
                    <br />
                    <br />
                    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in
                    the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
                    the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
                    <br />
                    <br />
                    The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
                    <br />
                    <br />
                    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR
                    A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
                    ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                </Typography>
            </Grid>
            <Grid xs={12}>
                <Typography sx={{ fontFamily: 'CircularProMedium', fontSize: '14px !important', color: '#212121' }}>Leaflet</Typography>
                <Typography sx={{ fontSize: '14px !important', color: '#757575' }}>
                    BSD 2-Clause License
                    <br />
                    <br />
                    Copyright (c) 2010-2023, Volodymyr Agafonkin
                    <br />
                    Copyright (c) 2010-2011, CloudMade
                    <br />
                    All rights reserved.
                    <br />
                    <br />
                    Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
                    <br />
                    <ol>
                        <li>Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.</li>
                        <li>
                            Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation
                            and/or other materials provided with the distribution.
                        </li>
                    </ol>
                    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
                    WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY
                    DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF
                    USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
                    NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.RE.
                </Typography>
            </Grid>
            <Grid xs={12}>
                <Typography sx={{ fontFamily: 'CircularProMedium', fontSize: '14px !important', color: '#212121' }}>Moment</Typography>
                <Typography sx={{ fontSize: '14px !important', color: '#757575' }}>
                    Copyright (c) JS Foundation and other contributors
                    <br />
                    <br />
                    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in
                    the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
                    the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
                    <br />
                    <br />
                    The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
                    <br />
                    <br />
                    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR
                    A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
                    ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                </Typography>
            </Grid>
            <Grid xs={12}>
                <Typography sx={{ fontFamily: 'CircularProMedium', fontSize: '14px !important', color: '#212121' }}>unDraw</Typography>
                <Typography sx={{ fontSize: '14px !important', color: '#757575' }}>
                    Copyright 2023 Katerina Limpitsouni
                    <br />
                    <br />
                    All images, assets and vectors published on unDraw can be used for free. You can use them for noncommercial and commercial purposes. You do not need to ask
                    permission from or provide credit to the creator or unDraw.
                    <br />
                    <br />
                    More precisely, unDraw grants you an nonexclusive, worldwide copyright license to download, copy, modify, distribute, perform, and use the assets provided from
                    unDraw for free, including for commercial purposes, without permission from or attributing the creator or unDraw. This license does not include the right to
                    compile assets, vectors or images from unDraw to replicate a similar or competing service, in any form or distribute the assets in packs or otherwise. This
                    extends to automated and non-automated ways to link, embed, scrape, search or download the assets included on the website without our consent.
                    <br />
                    <br />
                    <strong>Regarding brand logos that are included:</strong>
                    <br />
                    Are registered trademarks of their respected owners. Are included on a promotional basis and do not represent an association with unDraw or its users. Do not
                    indicate any kind of endorsement of the trademark holder towards unDraw, nor vice versa. Are provided with the sole purpose to represent the actual
                    brand/service/company that has registered the trademark and must not be used otherwise.
                </Typography>
            </Grid>
        </Grid>
    );
}
